function getUrlParams() {
  const search = window.location.search

  if (!search.length) return {}
  const groups = search.slice(search.indexOf('?') + 1).split('&')
  const params = {}
  groups.forEach(group => {
    let [key, val] = group.split('=')
    params[key] = decodeURIComponent(val)
  })

  return params
}

export default getUrlParams
